import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WbAutoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wb_auto"}/>
}
